import {styled, FieldErrorText} from "@reside/ui";
import {taskCheckboxFadedSmallOverrides} from "../../../../task-checkbox-field";
import {BackdropSpinner} from "../../../../spinner";

/**
 * Shared grid for checklist rows (plain string — no @emotion/react css`` helper).
 * Child text stack must set data-checklist-item-text-column (see ChecklistItemTextColumn.tsx).
 */
const CHECKLIST_ROW_GRID = `
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto auto;
  column-gap: 4px;
  row-gap: 2px;
  align-items: start;
  width: 100%;
  min-width: 0;

  input[type="checkbox"] {
    grid-column: 1;
    grid-row: 1;
    align-self: center;
  }

  #checkbox-icon {
    grid-column: 1;
    grid-row: 1;
    align-self: center;
  }

  > [data-task-checkbox-trailing] {
    grid-column: 3;
    grid-row: 1;
    margin-left: 0 !important;
    align-self: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    min-width: 0;
  }

  > [data-checklist-item-text-column] {
    grid-column: 2;
    grid-row: 1;
    min-width: 0;
    align-self: center;
  }
`;

/** Completion date in the trailing column (with caret); visibility follows Label hover rules in task-checkbox-field/styles. */
export const ChecklistItemDateHoverSlot = styled.div<{size: "small" | "medium"}>`
  padding: 0;
  line-height: 1.2;
  flex-shrink: 0;

  time {
    font-size: ${({size}) => (size === "small" ? "12px" : "14px")};
    color: ${({theme}) => theme.color.gray100};
    margin-left: 0 !important;
    white-space: nowrap;
  }
`;

/** Checked/edited date under label — compact, muted. */
export const ChecklistItemDate = styled.div<{size: "small" | "medium"}>`
  padding: 0 5px;
  line-height: 1.2;

  time {
    font-size: ${({size}) => (size === "small" ? "12px" : "14px")};
    color: ${({theme}) => theme.color.gray100};
    margin-left: 0 !important;
    white-space: normal;
  }
`;

export const Label = styled(taskCheckboxFadedSmallOverrides.Label)`
  ${CHECKLIST_ROW_GRID}

  padding-left: 15px;
  padding-right: 15px;

  /* PCC upload rows wrap checkbox + label + trailing in one wrapper div. As the only grid
     child it defaults to column 1 (auto width), so the row shrink-wraps and upload icons
     hug the label. Non-PCC rows use checkbox + text column siblings and fill width. */
  & > *:only-child {
    grid-column: 1 / -1;
    width: 100%;
    min-width: 0;
  }
`;

/** Same grid as dashboard Label for PCC upload rows. */
export const PccCheckboxRow = styled.div`
  ${CHECKLIST_ROW_GRID}
  flex: 1;
  min-width: 0;
`;

export const SmallFieldErrorText = styled(FieldErrorText)`
  font-size: 14px;
`;

export const PositionedBackdropSpinner = styled(BackdropSpinner)`
  margin: 5px -15px;

  .spinner {
    position: absolute;
  }
`;

export {ChecklistItemTextColumn} from "./ChecklistItemTextColumn";
